import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const ProBadge = (props) => (
    <svg
        fill='none'
        height='24'
        viewBox='0 0 24 15'
        width='15'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <g clipPath='url(#clip0_11425_30)'>
            <path
                d='M2.82362 0.352966H21.1766C22.541 0.352966 23.6471 1.45908 23.6471 2.82355V11.2941C23.6471 12.6586 22.541 13.7647 21.1766 13.7647H2.82362C1.45914 13.7647 0.353027 12.6586 0.353027 11.2941V2.82355C0.353027 1.45908 1.45914 0.352966 2.82362 0.352966Z'
                fill='black'/>
            <path
                d='M2.82362 0.352966H21.1766C22.541 0.352966 23.6471 1.45908 23.6471 2.82355V11.2941C23.6471 12.6586 22.541 13.7647 21.1766 13.7647H2.82362C1.45914 13.7647 0.353027 12.6586 0.353027 11.2941V2.82355C0.353027 1.45908 1.45914 0.352966 2.82362 0.352966Z'
                stroke='black'
                strokeWidth='0.705882'/>
            <path
                d='M5.89837 6.77363C6.50825 6.77363 6.94872 6.48563 6.94872 5.8588C6.94872 5.24045 6.50825 4.94398 5.89837 4.94398H4.67013V6.77363H5.89837ZM3.44189 9.88233V3.91057H5.96613C7.32142 3.91057 8.21084 4.60516 8.21084 5.8588C8.21084 7.12092 7.32142 7.81551 5.96613 7.81551H4.67013V9.88233H3.44189ZM9.05034 9.88233V3.91057H11.5915C12.879 3.91057 13.8193 4.52045 13.8193 5.74021C13.8193 6.73974 13.2433 7.31574 12.3623 7.51904L13.8447 9.88233H12.4216L11.0833 7.60374H10.2786V9.88233H9.05034ZM10.2786 6.60421H11.5576C12.1336 6.60421 12.5572 6.34163 12.5572 5.76563C12.5572 5.18963 12.1336 4.91857 11.5576 4.91857H10.2786V6.60421ZM17.4584 10.0094C15.7219 10.0094 14.6123 8.7388 14.6123 6.89221C14.6123 5.0541 15.7219 3.78351 17.4584 3.78351C19.1949 3.78351 20.3045 5.0541 20.3045 6.89221C20.3045 8.7388 19.1949 10.0094 17.4584 10.0094ZM17.4584 8.91668C18.4156 8.91668 19.0424 8.19668 19.0424 6.89221C19.0424 5.58774 18.4156 4.87621 17.4584 4.87621C16.5012 4.87621 15.8744 5.58774 15.8744 6.89221C15.8744 8.19668 16.5012 8.91668 17.4584 8.91668Z'
                fill='white'/>
        </g>
        <defs>
            <clipPath id='clip0_11425_30'>
                <rect
                    fill='white'
                    height='14.1176'
                    width='24'/>
            </clipPath>
        </defs>
    </svg>
);

export default ProBadge;
